/* 系统基础API */

import { GET, GETNEW, POST, POSTNEW, uploadingImg, DELETE, PUT } from '@/request/http'
// 获取主题
export const getThemeInfo = p => GET('/basic/theme/info/collegeUrl', p)

// 忘记密码
export const expwd = p => POST('/basic/user/password/retrievepassword', p)


// 修改手机号
export const updatePhone = p => POST('/basic/user/update/updatephone', p)

// 获取验证码
export const getVerifyCode = p => POST('/basic/login/verifycode/send', p)
// 获取部门树
export const getDeptTree = p => GETNEW('/basic/departments/dept-tree', p)

// 工号密码登录
export const apiLogin = p => POST('/basic/sys-login/XG/XG_TEA_PC/loginByJobNumber', p)
// 手机号验证码登录
export const apiLoginByPhoneNumber = p => POST('/basic/sys-login/XG/XG_TEA_PC/loginByPhoneNumber', p)
// 更新token
export const updateToken = p => PUT('/basic/jwt', p)

//修改用户信息
export const updateUser = p => POST('/SysUser/updateProfile', p)

// 更新密码
export const updatePWD = p => POST('/SysUser/updatePassword', p)

//获取当前用户权限菜单
export const apiGetMenu = p => POST('/basic/authrizer/menu/list/bycurrentuser', p)

// 获取当前用户有权限的顶级菜单
export const getTopMenuF = p => GET('/basic/sys-permission/all-sub-list/-1', p)

// 获取当全量顶级菜单
export const getTopMenuT = p => GET('/basic/sys-permission/top-menu/true', p)

// 获取当全量顶级菜单
export const getOfficeMenu = p => GET('/basic/sys-permission/sub-list/all', p)

// 获取当全量顶级菜单
export const getOfficeMenuByName = p => GETNEW('/basic/sys-permission/find/permissionName', p)
// 获取学校区域信息
export const getLocationByCollegeId = p => POSTNEW('/dormv2/room/location/list/byCollegeId', p)
// 获取房间号
export const getDormNoByBuildingAndFloor = p => GETNEW('/dormv2/room/list/DormNoByBuildingAndFloor', p)

//获取区域
export const getCampus = p => POST('/basic/location/campus/get', p)
//根据校区id获取区域
export const getAreaByCampus = p => POST('/basic/location/area/list/bycampusid', p)
//新增区域
export const addArea = p => POST('/basic/location/area/save', p)
//编辑区域
export const editArea = p => POST('/basic/location/area/update', p)
//删除区域
export const delArea = p => POST('/basic/location/area/remove', p)

//根据区域id获取楼宇
export const getBuildByArea = p => POST('/basic/location/building/list/byareaid', p)
//新增楼宇
export const addBuilding = p => POST('/basic/location/building/save', p)
//编辑楼宇
export const editBuilding = p => POST('/basic/location/building/update', p)
//删除楼宇
export const delBuilding = p => POST('/basic/location/building/remove', p)

//获取当前用户信息
export const getUserInfo = p => GET('/basic/sys-user/getLoginUserInfo', p)

/*
* 新首页
*/
// 获取我的常用菜单
export const getUsedMenu = p => GET('/basic/sys-permission/my-function', p)

// 新增常用菜单
export const updateUsedMenu = p => POST('/basic/my-function/save', p)

// 获取二级菜单
export const getMenuById = p => GET('/basic/sys-permission/all-sub-list/{permissionId}', p)


/**
 * 位置管理
 */
// 查询权限所有位置信息
export const getLocationList = p => POST('/basic/location/tree/list', p)
//查询位置列表
export const getLocationByParentId = p => GET('/basic/locations', p)
// 新增位置
export const addLocation = p => POST('/basic/location/save', p)
// 更新位置基础信息
export const updateLocation = p => POST('/basic/location/update', p)
// 更新楼宇信息
export const updateLocationBuilding = p => POST('/basic/location/building/update', p)
// 更新校区信息
export const updateLocationCampus = p => POST('/basic/location/campus/update', p)
// 根据位置id获取楼宇信息
export const getBuildingByLocationId = p => POST('/basic/location/building/get/bylocationid', p)
// 根据位置id获取校区信息
export const getCampusByLocationId = p => POST('/basic/location/campus/get/bylocationid', p)
// 获取学校校区树
export const getCampusList = p => POST('/basic/location/collegeandcampustree/list', p)
// 获取楼宇信息 可以根据学校筛选
export const getBuildingList = p => GET('/basic/location/buildings', p)
// 根据id查询位置信息
export const getLocationById = p => POST('/basic/location/get', p)

/**
 * 用户管理
 */
// 根据组织id查询用户
export const getUserByOrgId = p => POST('/basic/user/list/bycurrentuserorg', p)
// 根据组织id查询用户
export const addUser = p => POST('/basic/user/systemuser/save', p)
// 编辑用户
export const editUser = p => POST('/basic/user/update', p)
// 根据id删除用户
export const delUser = p => POST('/basic/user/remove', p)
// 更新用户绑定组织
export const updateUserOrg = p => POST('/basic/user/org/update', p)
// 更新用户绑定角色
export const updateUserRole = p => POST('/basic/user/role/update', p)
// 更新用户绑定角色
export const getRoleByUserId = p => POST('/basic/authrizer/role/list/byuserid', p)

/**
 * 位置权限
 */
// 根据组织id查询位置
export const getLocationByOrgId = p => POST('/basic/orgduty/location/singlelevel/bindedbyorg/list/byorgid', p)
// 查询当前用户权限下的位置
export const getLocationByUser = p => POST('/basic/duty/location/tree/fororg/list/bycurrentuser', p)
// 更新组织绑定的位置
export const updateOrgLocation = p => POST('/basic/orgduty/location/update', p)

// 获取组织树
export const getOrgTree = p => POST('/basic/org/orgtree/get/bycurrentuser', p)

// 新增组织
export const addOrg = p => POST('/basic/org/save', p)

// 编辑组织
export const editOrg = p => POST('/basic/org/update', p)

// 删除组织
export const delOrg = p => POST('/basic/org/remove', p)
//查询角色
export const getRoleList = p => POST('/basic/authrizer/role/list', p)
//新增角色
export const addRole = p => POST('/basic/authrizer/role/save', p)
//编辑角色
export const editRole = p => POST('/basic/authrizer/role/update', p)
//删除角色
export const delRole = p => POST('/basic/authrizer/role/remove', p)
//查询权限列表
export const getPermissionList = p => POST('/basic/authrizer/permission/list', p)
//查询角色绑定权限
export const getRolePermission = p => POST('/basic/authrizer/permission/list/byroleid', p)
//更新角色绑定权限
export const rolePermessionUpdata = p => POST('/basic/authrizer/role/permission/update', p)
// 根据当前用户修改密码
export const updatePWDBySeft = p => POST('/basic/user/password/update/bycurrentuser', p)
// 更新用户信息
export const updateUserInfo = p => POST('/basic/user/update/bycurrentuser', p)

/**
 * 部门管理
 */
//查询部门
export const getDepartmentList = p => GET('/basic/departments', p)
//新增部门
export const increaseDepartment = p => POST('/basic/departments', p)
//修改部门
export const editDepartment = p => PUT('/basic/departments/{dept_id}', p)
//查询部门详情
export const getDepartmentDetail = p => GET('/basic/departments/{dept_id}', p)
//删除部门
export const deleteDepartment = p => DELETE('/basic/departments/{dept_id}', p)
//查询部门详情
export const searchForDepartmentDetail = p => GET('/basic/departments/{dept_id}', p)
//查询部门成员列表
export const getDepartmentMemberList = p => GET('/basic/departments/{dept_id}/members', p)
//添加成员
export const increaseDepartmentMember = p => POST('/basic/departments/{dept_id}/members', p)
//删除成员
export const deleteDepartmentMember = p => DELETE('/basic/departments/{dept_id}/members/{member_id}', p)
//删除成员
export const aeuploadFiles = p => uploadingImg('/basic/aliyun-oos/upload-file/basic', p)
/**
 * 职员管理
 */
//添加员工
export const saveEmployee = p => POST('/basic/user/employee/save', p)
//查询员工列表
export const getEmployeeList = p => POST('/basic/user/employee/list', p)
//从组织中移除员工
export const removeEmployee = p => POST('/basic/user/employee/remove', p)
//查询当前用户组织名称
export const getCurrentUserOrgName = p => POST('/basic/user/employee/orgname/get/bycurrentuser', p)
//更新用户部门
export const updateEmployeeDepartment = p => POST('/basic/user/employee/deptid/update', p)
//获取民族
export const getNation = p => GETNEW('/studentv2/nation/list', p)

//判断当前账号密码是否是初始密码 
export const checkPasswordOrigin = p => GETNEW('/basic/login/checkLogin', p)


// WEBPACK FOOTER //
// ./src/api/modules/base.js